export default "__VITE_ASSET__nqGRbsW$__"